import React, { Component } from "react";
import PropTypes from "prop-types";
import { Map, List, fromJS } from "immutable";
import ImPropTypes from "react-immutable-proptypes";
import { profiles } from "../App";

export default class AceParameters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      callbackVisible: false,
      parametersVisible: true,
      profile: null,
    };
  }

  static propTypes = {
    parameters: ImPropTypes.list.isRequired,
    operation: PropTypes.object.isRequired,
    specActions: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired,
    specSelectors: PropTypes.object.isRequired,
    oas3Actions: PropTypes.object.isRequired,
    oas3Selectors: PropTypes.object.isRequired,
    fn: PropTypes.object.isRequired,
    tryItOutEnabled: PropTypes.bool,
    allowTryItOut: PropTypes.bool,
    onTryoutClick: PropTypes.func,
    onCancelClick: PropTypes.func,
    onChangeKey: PropTypes.array,
    pathMethod: PropTypes.array.isRequired,
    getConfigs: PropTypes.func.isRequired,
    specPath: ImPropTypes.list.isRequired,
    profile: PropTypes.string,
  };

  static defaultProps = {
    onTryoutClick: Function.prototype,
    onCancelClick: Function.prototype,
    tryItOutEnabled: false,
    allowTryItOut: true,
    onChangeKey: [],
    specPath: [],
  };

  onChange = (param, value, isXml) => {
    let {
      specActions: { changeParamByIdentity },
      onChangeKey,
    } = this.props;

    changeParamByIdentity(onChangeKey, param, value, isXml);
  };

  onChangeConsumesWrapper = (val) => {
    let {
      specActions: { changeConsumesValue },
      onChangeKey,
    } = this.props;

    changeConsumesValue(onChangeKey, val);
  };

  toggleTab = (tab) => {
    if (tab === "parameters") {
      return this.setState({
        parametersVisible: true,
        callbackVisible: false,
      });
    } else if (tab === "callbacks") {
      return this.setState({
        callbackVisible: true,
        parametersVisible: false,
      });
    }
  };

  onChangeMediaType = ({ value, pathMethod }) => {
    let { specActions, oas3Selectors, oas3Actions } = this.props;
    const userHasEditedBody = oas3Selectors.hasUserEditedBody(...pathMethod);
    const shouldRetainRequestBodyValue =
      oas3Selectors.shouldRetainRequestBodyValue(...pathMethod);
    oas3Actions.setRequestContentType({ value, pathMethod });
    oas3Actions.initRequestBodyValidateError({ pathMethod });
    if (!userHasEditedBody) {
      if (!shouldRetainRequestBodyValue) {
        oas3Actions.setRequestBodyValue({ value: undefined, pathMethod });
      }
      specActions.clearResponse(...pathMethod);
      specActions.clearRequest(...pathMethod);
      specActions.clearValidateParams(pathMethod);
    }
  };

  onChangeMediaTypeWithProfiles = ({ value, pathMethod, operationId }) => {
    let profile = fromJS(Object.keys(profiles[operationId])).first();
    let { oas3Actions } = this.props;
    oas3Actions.setRequestContentType({ value, pathMethod });
    oas3Actions.initRequestBodyValidateError({ pathMethod });
    const newRequestBody =
      profiles[operationId][value.includes("json") ? "json" : "xml"][
        this.state.profile === null ? profile : this.state.profile
      ];
    oas3Actions.setRequestBodyValue({ value: newRequestBody, pathMethod });
  };

  onChangeProfile = (profile, operationId) => {
    if (this.state.profile !== profile) {
      this.setState({ profile: profile });
      let { oas3Actions, oas3Selectors, pathMethod } = this.props;
      const contentType = oas3Selectors.requestContentType(...pathMethod);
      const newRequestBody =
        profiles[operationId][contentType.includes("json") ? "json" : "xml"][
          profile
        ];
      oas3Actions.setRequestBodyValue({ value: newRequestBody, pathMethod });
    }
  };

  onReset = (operationId) => {
    let { oas3Actions, oas3Selectors, pathMethod } = this.props;
    const contentType = oas3Selectors.requestContentType(...pathMethod);
    const requestBody =
      profiles[operationId][contentType.includes("json") ? "json" : "xml"][
        this.state.profile
      ];
    oas3Actions.setRequestBodyValue({ value: requestBody, pathMethod });
  };

  getRequestBodyValue = (operationId) => {
    let { oas3Actions, oas3Selectors, pathMethod } = this.props;
    const userEditedBody = oas3Selectors.hasUserEditedBody(...pathMethod);
    const shouldRetainRequestBodyValue =
      oas3Selectors.shouldRetainRequestBodyValue(...pathMethod);
    if (this.state.profile !== null && !userEditedBody) {
      const contentType = oas3Selectors.requestContentType(...pathMethod);
      const requestBody =
        profiles[operationId][
          !contentType || contentType.includes("json") ? "json" : "xml"
        ][this.state.profile];
      oas3Actions.setRequestBodyValue({ value: requestBody, pathMethod });
      return requestBody;
    }
    return oas3Selectors.requestBodyValue(...pathMethod);
  };

  profilesLoaded = (operationId) => {
    if (operationId in profiles) {
      return Object.keys(profiles[operationId]).length > 0;
    }
    return false;
  };

  render() {
    let {
      onTryoutClick,
      parameters,
      allowTryItOut,
      tryItOutEnabled,
      specPath,
      fn,
      getComponent,
      getConfigs,
      specSelectors,
      specActions,
      pathMethod,
      oas3Actions,
      oas3Selectors,
      operation,
    } = this.props;

    const ParameterRow = getComponent("parameterRow");
    const TryItOutButton = getComponent("TryItOutButton");
    const ContentType = getComponent("contentType");
    const Callbacks = getComponent("Callbacks", true);
    const RequestBody = getComponent("RequestBody", true);

    const isExecute = tryItOutEnabled && allowTryItOut;
    const isOAS3 = specSelectors.isOAS3();

    const requestBody = operation.get("requestBody");
    const operationId = operation.get("operationId");
    const contentType = oas3Selectors.requestContentType(...pathMethod);
    const language =
      !contentType || contentType.includes("json") ? "json" : "xml";

    const groupedParametersArr = Object.values(
      parameters.reduce((acc, x) => {
        const key = x.get("in");
        acc[key] ?? (acc[key] = []);
        acc[key].push(x);
        return acc;
      }, {})
    ).reduce((acc, x) => acc.concat(x), []);

    const retainRequestBodyValueFlagForOperation = (f) =>
      oas3Actions.setRetainRequestBodyValueFlag({ value: f, pathMethod });
    return (
      <div className="opblock-section">
        <div className="opblock-section-header">
          {isOAS3 ? (
            <div className="tab-header">
              <div
                onClick={() => this.toggleTab("parameters")}
                className={`tab-item ${
                  this.state.parametersVisible && "active"
                }`}
              >
                <h4 className="opblock-title">
                  <span>Parameters</span>
                </h4>
              </div>
              {operation.get("callbacks") ? (
                <div
                  onClick={() => this.toggleTab("callbacks")}
                  className={`tab-item ${
                    this.state.callbackVisible && "active"
                  }`}
                >
                  <h4 className="opblock-title">
                    <span>Callbacks</span>
                  </h4>
                </div>
              ) : null}
            </div>
          ) : (
            <div className="tab-header">
              <h4 className="opblock-title">Parameters</h4>
            </div>
          )}
          {allowTryItOut ? (
            <TryItOutButton
              isOAS3={specSelectors.isOAS3()}
              hasUserEditedBody={oas3Selectors.hasUserEditedBody(...pathMethod)}
              enabled={tryItOutEnabled}
              onCancelClick={this.props.onCancelClick}
              onTryoutClick={onTryoutClick}
              onResetClick={
                this.profilesLoaded(operationId)
                  ? () => this.onReset(operationId)
                  : () => oas3Actions.setRequestBodyValue({
                      value: undefined,
                      pathMethod,
                    })
              }
            />
          ) : null}
        </div>
        {this.state.parametersVisible ? (
          <div className="parameters-container">
            {!groupedParametersArr.length ? (
              <div className="opblock-description-wrapper">
                <p>No parameters</p>
              </div>
            ) : (
              <div className="table-container">
                <table className="parameters">
                  <thead>
                    <tr>
                      <th className="col_header parameters-col_name">Name</th>
                      <th className="col_header parameters-col_description">
                        Description
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupedParametersArr.map((parameter, i) => (
                      <ParameterRow
                        fn={fn}
                        specPath={specPath.push(i.toString())}
                        getComponent={getComponent}
                        getConfigs={getConfigs}
                        rawParam={parameter}
                        param={specSelectors.parameterWithMetaByIdentity(
                          pathMethod,
                          parameter
                        )}
                        key={`${parameter.get("in")}.${parameter.get("name")}`}
                        onChange={this.onChange}
                        onChangeConsumes={this.onChangeConsumesWrapper}
                        specSelectors={specSelectors}
                        specActions={specActions}
                        oas3Actions={oas3Actions}
                        oas3Selectors={oas3Selectors}
                        pathMethod={pathMethod}
                        isExecute={isExecute}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ) : null}

        {this.state.callbackVisible ? (
          <div className="callbacks-container opblock-description-wrapper">
            <Callbacks
              callbacks={Map(operation.get("callbacks"))}
              specPath={specPath.slice(0, -1).push("callbacks")}
            />
          </div>
        ) : null}
        {isOAS3 && requestBody && this.state.parametersVisible && (
          <div className="opblock-section opblock-section-request-body">
            <div className="opblock-section-header">
              <h4
                className={`opblock-title parameter__name ${
                  requestBody.get("required") && "required"
                }`}
              >
                Request body
              </h4>
              <label>
                <ContentType
                  value={oas3Selectors.requestContentType(...pathMethod)}
                  contentTypes={requestBody.get("content", List()).keySeq()}
                  onChange={(value) => {
                    this.profilesLoaded(operationId)
                      ? this.onChangeMediaTypeWithProfiles({
                          value,
                          pathMethod,
                          operationId,
                        })
                      : this.onChangeMediaType({ value, pathMethod });
                  }}
                  className="body-param-content-type"
                  ariaLabel="Request content type"
                />
              </label>
            </div>
            <div className="opblock-description-wrapper">
              <RequestBody
                setRetainRequestBodyValueFlag={
                  retainRequestBodyValueFlagForOperation
                }
                userHasEditedBody={oas3Selectors.hasUserEditedBody(
                  ...pathMethod
                )}
                specPath={specPath.slice(0, -1).push("requestBody")}
                requestBody={requestBody}
                requestBodyValue={this.getRequestBodyValue(operationId)}
                requestBodyInclusionSetting={oas3Selectors.requestBodyInclusionSetting(
                  ...pathMethod
                )}
                requestBodyErrors={oas3Selectors.requestBodyErrors(
                  ...pathMethod
                )}
                isExecute={isExecute}
                getConfigs={getConfigs}
                activeExamplesKey={oas3Selectors.activeExamplesMember(
                  ...pathMethod,
                  "requestBody",
                  "requestBody" // RBs are currently not stored per-mediaType
                )}
                updateActiveExamplesKey={(key) => {
                  this.props.oas3Actions.setActiveExamplesMember({
                    name: key,
                    pathMethod: this.props.pathMethod,
                    contextType: "requestBody",
                    contextName: "requestBody", // RBs are currently not stored per-mediaType
                  });
                }}
                onChange={(value, path) => {
                  if (path) {
                    const lastValue = oas3Selectors.requestBodyValue(
                      ...pathMethod
                    );
                    const usableValue = Map.isMap(lastValue)
                      ? lastValue
                      : Map();
                    return oas3Actions.setRequestBodyValue({
                      pathMethod,
                      value: usableValue.setIn(path, value),
                    });
                  }
                  oas3Actions.setRequestBodyValue({ value, pathMethod });
                }}
                onChangeIncludeEmpty={(name, value) => {
                  oas3Actions.setRequestBodyInclusion({
                    pathMethod,
                    value,
                    name,
                  });
                }}
                contentType={oas3Selectors.requestContentType(...pathMethod)}
                profile={this.state.profile}
                profiles={
                  operationId in profiles
                    ? fromJS(
                        Object.keys(profiles[operationId][language]),
                        (k, v) => v.toOrderedMap()
                      )
                    : null
                }
                onChangeProfile={(profile) =>
                  this.onChangeProfile(profile, operationId)
                }
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
